import { Form } from "antd";
import React from "react";
import { InputNumberStd } from "src/components/InputNumberStd";
import { edCompField } from "../ParamsEditorInfo2";
import { Addon } from "./common";

export const InputEdProps: React.FC = () => (
  <>
    <Form.Item
      name={edCompField("maxLength")}
      label="Максимальное количество символов"
    >
      <InputNumberStd precision={0} />
    </Form.Item>
    <Addon />
  </>
);
